module.exports = __webpack_public_path__ + "44f020cb5e59483ec2c6a5f3ede4ca41.pdf";